<template>
  <div class="result">
    <div class="alert alert-danger" role="alert" v-if="errorMsg">
      {{ errorMsg }}
    </div>
    <div
      v-for="(widgetsOfSameType, index) in widgets"
      :key="widgetsOfSameType[0] ? widgetsOfSameType[0].id : index"
    >
      <div class="widgets-group">
        <div class="toggle-button" @click="toggleWdigetsGroup(index)">
          <span>
            {{
              isShowWidgetsGroup[index]
                ? $t('comparisonFeature.results.hideBtn')
                : $t('comparisonFeature.results.showBtn')
            }}
          </span>
          <fa v-show="isShowWidgetsGroup[index]" icon="chevron-up"></fa>
          <fa v-show="!isShowWidgetsGroup[index]" icon="chevron-down"></fa>
        </div>
        <div class="tool-name">
          <div class="tool-name__line"></div>
          <div class="tool-name__text">{{ getToolName(index) }}</div>
          <div class="tool-name__line"></div>
        </div>
        <div class="tool-reminder" v-if="widgetsOfSameType.length === 0">
          {{ $t('comparisonFeature.results.promptNotAvailable') }}
        </div>
        <swiper
          :options="swiperOption"
          ref="mySwiper"
          v-if="widgetsOfSameType.length > 0"
          v-show="isShowWidgetsGroup[index]"
        >
          <swiper-slide
            v-for="widget in widgetsOfSameType"
            :key="widget.widgetObject.selector"
          >
            <div
              class="card swiper-no-swiping"
              style="text-align: center"
              @mouseenter="onMouseEnter()"
              @mouseleave="onMouseLeave(widget.widgetObject.selector)"
            >
              <div
                v-if="widget.widgetObject.widgetName"
                v-bind:id="widget.widgetObject.selector"
                class="card-body"
              ></div>
              <div
                class="card-body none-widget"
                v-if="!widget.widgetObject.widgetName"
              >
                <p class="title">
                  {{ widget.widgetObject.selector }}
                </p>
                <p class="description">
                  {{
                    $t(
                      'comparisonFeature.results.promptNotAvailableForCurrentResource'
                    )
                  }}
                </p>
              </div>
            </div>
          </swiper-slide>
          <!-- <div class="swiper-pagination" slot="pagination"></div> -->
          <div class="swiper-button-prev" slot="button-prev">
            <fa icon="chevron-left"></fa>
          </div>
          <div class="swiper-button-next" slot="button-next">
            <fa icon="chevron-right"></fa>
          </div>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'swiper/dist/css/swiper.css';

export default {
  components: { swiper, swiperSlide },
  props: ['tabId'],
  data() {
    return {
      timer: 0,
      isShowWidgetsGroup: [],
    };
  },
  computed: {
    ...mapState(['selectedComparisonToolList', 'isNarrowWidthDevice']),
    ...mapGetters(['currentWidgets', 'errorMsg']),
    widgets() {
      return this.currentWidgets(this.tabId);
    },
    swiper() {
      return this.$refs.mySwiper ? this.$refs.mySwiper.swiper : null;
    },
    swiperOption() {
      return {
        // loopedSlides: 2, //if loop is true, use loopedSlides as well
        loop: false,
        autoplay: false,
        slidesPerView: window.innerWidth < 768 ? 1 : 2,
        spaceBetween: 56,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        // set noWiping as true to enable this function, also it is required to add swiper-no-swiping into the class name of the element
        // set noSwiping as true in both Desktop and Mobile devices to enable users select/copy text in widgets and drag within widgets to show the full content (mainly for mobile users)
        noSwiping: true,
      };
    },
  },
  methods: {
    load(widgets) {
      // wait for the dom render first
      // jquery need the dom to be ready
      this.$nextTick(() => {
        widgets.forEach((widgetsWithSameType) => {
          widgetsWithSameType.forEach((widget) => {
            // If widgetName does not exist, which means this tool is not available for the Internet number, do not load widget
            if (!widget.widgetObject.widgetName) return;

            const { params, selector, styling, widgetName } =
              widget.widgetObject;
            window.ripestat.init(widgetName, params, selector, styling);
          });
        });
      });
    },

    onMouseEnter() {
      this.timer = new Date();
    },

    onMouseLeave(id) {
      const diff = new Date() - this.timer;
      if (diff > 2000) {
        window.dataLayer.push({
          event: 'widgetHover',
          widgetName: id.split('_')[1],
        });
      }
    },

    getToolName(index) {
      const toolName = this.selectedComparisonToolList[index].name;

      return toolName.startsWith('-') ? 'AS/Prefix' + toolName : toolName;
    },

    toggleWdigetsGroup(index) {
      // To deep copy this.isShowWidgetsGroup, otherwise the v-show status won't be changed
      this.isShowWidgetsGroup = [...this.isShowWidgetsGroup];
      this.isShowWidgetsGroup[index] = !this.isShowWidgetsGroup[index];
    },
  },
  mounted() {
    this.load(this.widgets);
    this.isShowWidgetsGroup = this.selectedComparisonToolList.map(() => true);

    // manipulate swiper via this.swiper
    // this.swiper.slideTo(0, 1000, false);
  },
};
</script>

<style scoped lang="scss">
.result {
  position: relative;
  margin: 0;
  margin-top: 1rem;
}

.alert {
  margin-top: 2rem;
}

.none-widget {
  height: 25rem;

  .title {
    line-height: 1rem;
    font-size: 0.8rem;
    font-weight: 600;
    color: $text-black;
  }

  .description {
    padding-top: 8rem;
    height: 20rem;
    line-height: 1.5rem;
  }
}

@include widget-card;

.card-body {
  width: 100% !important;
}

.widgets-group {
  margin-top: 1rem;
}

.widgets-group .swiper-container {
  position: relative;
  width: 100%;
  background-color: #f5f5f7;
}

.widgets-group .swiper-container .swiper-slide {
  /* width: 300px !important; */
  line-height: 200px;
  color: #000;
  font-size: 16px;
  text-align: center;
}

.swiper-container {
  padding: 0 3rem;
}

.swiper-button-prev {
  left: 0rem;
  top: 50%;
  transform: translateY(-50%);
  width: 2rem;
  height: 20rem;
  line-height: 20rem;
  text-align: center;
  color: $text-light-blue;
  background-image: none;

  &:hover {
    svg {
      width: 4.6rem;
      height: 4.6rem;
      left: -1.2rem;
    }
  }

  svg {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -1rem;
    width: 4rem;
    height: 4rem;
    transition: all 0.3s;
  }
}

.swiper-button-next {
  right: 0rem;
  top: 50%;
  transform: translateY(-50%);
  width: 2rem;
  height: 20rem;
  line-height: 20rem;
  text-align: center;
  color: $text-light-blue;
  background-image: none;

  &:hover {
    svg {
      width: 4.6rem;
      height: 4.6em;
      right: -1.2rem;
    }
  }

  svg {
    position: absolute;
    right: -1rem;
    top: 50%;
    transform: translateY(-50%);
    width: 4rem;
    height: 4rem;
    transition: all 0.3s;
  }
}

.tool-name {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  padding-top: 0;

  &__text {
    flex: 0 0 auto;
    padding: 0 1rem;
    color: $text-black;
    font-weight: 600;
  }

  &__line {
    border: 1px $text-light-blue solid;
    height: 0px;
    flex: 1 0 auto;
  }
}

.tool-reminder {
  text-align: center;
}

.toggle-button {
  text-align: right;
  padding-right: 1rem;

  span {
    font-size: 0.8rem;
    padding-right: 0.5rem;
  }

  &:hover {
    cursor: pointer;
  }
}

@include responsive(mobile) {
  .result {
    margin-right: -0.5rem;
    margin-left: -0.5rem;
  }

  .swiper-container {
    padding: 0 2rem;
  }

  .swiper-button-prev {
    width: 2rem;
    height: 3rem;
    line-height: 3rem;

    &:hover {
      svg {
        width: 4rem;
        height: 4rem;
        left: -1rem;
      }
    }
  }

  .swiper-button-next {
    width: 2rem;
    height: 3rem;
    line-height: 3rem;

    &:hover {
      svg {
        width: 4rem;
        height: 4rem;
        right: -1rem;
      }
    }
  }
}
</style>
